// @ts-nocheck
// Call Stats — chart color tokens, one semantic palette for the whole page
// (blue/green for call direction, green/amber/red for outcomes), mirroring
// ct-admin-dashboard's own useHex() convention.
//
const HEX_LIGHT = { call: '#2563eb', good: '#16a34a', warn: '#d97706', crit: '#dc2626', off: '#94a3b8' };
const HEX_DARK = { call: '#3b82f6', good: '#22c55e', warn: '#f59e0b', crit: '#ef4444', off: '#64748b' };

const OUTCOME_SUBTLE_LIGHT = { good: '#4c9a6b', warn: '#c98a3d', crit: '#c2564f' };
const OUTCOME_SUBTLE_DARK = { good: '#6bbf8f', warn: '#d9a05c', crit: '#d97b73' };

const PERIOD_ACCENTS_LIGHT = { today: '#2563eb', yesterday: '#7c3aed', this_week: '#0d9488' };
const PERIOD_ACCENTS_DARK = { today: '#60a5fa', yesterday: '#a78bfa', this_week: '#2dd4bf' };

export function getChartColors(isDark) {
  const hex = isDark ? HEX_DARK : HEX_LIGHT;
  const subtle = isDark ? OUTCOME_SUBTLE_DARK : OUTCOME_SUBTLE_LIGHT;
  return {
    hex,
    direction: [hex.call, hex.good], // Incoming, Outgoing
    outcome3: [subtle.good, subtle.warn, subtle.crit], 
    outcome2: [hex.good, hex.call], 
    axis: isDark ? '#94a3b8' : '#64748b',
    grid: isDark ? 'rgba(148,163,184,0.15)' : 'rgba(148,163,184,0.25)',
    emptyRing: isDark ? '#334155' : '#d1d5db',
    surface: isDark ? '#0b1220' : '#ffffff',
    strong: isDark ? '#e2e8f0' : '#1a2332',
    dim: isDark ? '#64748b' : '#94a3b8',
    periodAccents: isDark ? PERIOD_ACCENTS_DARK : PERIOD_ACCENTS_LIGHT,
  };
}
